import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {Avatar, Box} from "@mui/material";
import type {MouseEventHandler} from "react";
import {useTranslation} from "react-i18next";
import {useMe} from "../../common/useMe";
import {SidebarNavButton} from "./SidebarNavButton";
import {getUserAvatar} from "./userMenuAvatar";

interface UserMenuButtonProps {
    expanded: boolean;
    open: boolean;
    onClick: MouseEventHandler<HTMLButtonElement>;
}

export function UserMenuButton({expanded, open, onClick}: UserMenuButtonProps) {
    const {t} = useTranslation();
    const {user} = useMe();
    const {
        avatarColor,
        avatarInitials,
        avatarSrc,
        userName,
    } = getUserAvatar(user);

    return (
        <SidebarNavButton
            id="dashboard-user-menu-button"
            ariaControls={open ? "dashboard-user-menu" : undefined}
            ariaExpanded={open}
            ariaHaspopup="true"
            ariaLabel={t("Open user menu")}
            expanded={expanded}
            label={userName}
            labelFontWeight={700}
            labelMaxWidth={124}
            leading={(
                <Avatar
                    src={avatarSrc}
                    sx={{
                        width: 28,
                        height: 28,
                        fontSize: 11,
                        fontWeight: 700,
                        bgcolor: avatarColor,
                        color: "#fff",
                    }}
                >
                    {avatarInitials}
                </Avatar>
            )}
            onClick={onClick}
            tooltipTitle={t("User menu")}
            trailing={(
                <Box
                    sx={{
                        ml: "auto",
                        mr: 1.5,
                        width: expanded ? 18 : 0,
                        height: 18,
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        opacity: expanded ? 0.75 : 0,
                        overflow: "hidden",
                    }}
                >
                    <KeyboardArrowRightIcon sx={{fontSize: 18}}/>
                </Box>
            )}
        />
    );
}
